document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
        document.querySelectorAll('.dropdown-toggle').forEach(el => el.classList.remove('active'));
        toggle.classList.add('active');
    });
});

function showDropDown(elemento, options) {
    elemento.addEventListener("click", () => {
        options.classList.toggle("show");
    });
}

function unShowDropDown(elemento, options) {
    document.addEventListener("click", (e) => {
        if (!elemento.contains(e.target)) {
            options.classList.remove("show");
        }
    });
}

function dinamicaInputSelectOption(elemento, spanElemento, inputOculto, opcao, listaOpcoes) {
    const text = opcao.textContent;
    const divInserida = elemento.querySelector('.div-inserida');
    if (divInserida) divInserida.remove();

    elemento.insertAdjacentHTML('afterbegin', `<div class="div-inserida">${text}</div>`);
    elemento.classList.add("selected");
    spanElemento.classList.add("selected");
    inputOculto.value = text;
    listaOpcoes.classList.remove("show");
    
    atualizarEstadoBotao();
}

// Configuração Dropdown 1
const toggle = document.getElementById("relacaoToggle");
const options = document.getElementById("relacaoOptions");
const input = document.getElementById("relacaoInput");
const toggleSpan = toggle.children[0];

showDropDown(toggle, options);
unShowDropDown(toggle, options);

options.querySelectorAll("div").forEach(option => {
    option.addEventListener("click", () => {
        dinamicaInputSelectOption(toggle, toggleSpan, input, option, options);
        const value = option.getAttribute("data-value");
        document.querySelectorAll(".info").forEach(info => info.style.display = "none");
        
        const razaoSocialDiv = document.querySelector(".razaoSocial");
        const razaoInput = document.getElementById("razaoSocialInput");

        razaoInput.value = ""; // Limpa valor anterior

        if (value === "representante-cliente" || value === "representante-fornecedor") {
            document.getElementById(`info-${value}`).style.display = "block";
            razaoSocialDiv.style.display = "flex";
            razaoInput.setAttribute("required", "required");
            razaoInput.setAttribute("maxlength", "100");
        } else {
            const infoEl = document.getElementById(`info-${value}`) || document.getElementById("info-default");
            infoEl.style.display = "block";
            razaoSocialDiv.style.display = "none";
            razaoInput.removeAttribute("required");
            razaoInput.removeAttribute("maxlength");
        }
        atualizarEstadoBotao();
    });
});

// Configuração Dropdown 2
const toggle2 = document.getElementById("relacaoToggle2");
const options2 = document.getElementById("relacaoOptions2");
const input2 = document.getElementById("direitoInput");
const toggleSpan2 = toggle2.children[0];

showDropDown(toggle2, options2);
unShowDropDown(toggle2, options2);

options2.querySelectorAll("div").forEach(option => {
    const dataOption = option.getAttribute("data-value");
    const infoElement = document.querySelector(`.alert-option[data-value="${dataOption}"]`);

    option.addEventListener("mouseenter", () => infoElement.style.display = "block");
    option.addEventListener("mouseleave", () => {
        if (input2.value !== option.textContent) infoElement.style.display = "none";
    });

    option.addEventListener("click", () => {
        document.querySelectorAll('.alert-option').forEach(alert => alert.style.display = "none");
        infoElement.style.display = "block";

        dinamicaInputSelectOption(toggle2, toggleSpan2, input2, option, options2);

        const correcaoDiv = document.querySelector(".correcaoDados");
        const maisDetalheDiv = document.querySelector(".maisDetalhe");
        const inputCorrecao = document.getElementById("inputCorrecao");
        const maisDetalheTxt = document.getElementById("maisDetalhe");
        const arquivoInput = document.getElementById("arquivoInput");

        const blocoUm = document.querySelector(".correcaoDados-um");

        // RESET
        correcaoDiv.style.display = "flex"; 
        maisDetalheDiv.style.display = "none";
        blocoUm.style.display = "none";

        inputCorrecao.value = "";
        maisDetalheTxt.value = "";
        arquivoInput.value = "";

        // Reset visual do upload
        const label = document.querySelector('.upload-label');
        const sizeWarm = document.querySelector(".picture span");
        label.classList.remove('valid');
        sizeWarm.style.display = "none";

        inputCorrecao.removeAttribute("required");
        maisDetalheTxt.removeAttribute("required");
        arquivoInput.removeAttribute("required");

        // CONTROLE
        switch (dataOption) {
            case "confirmacao":
            case "correcao":
            case "oposicao":
            case "revogacao":
            case "revisao":
                maisDetalheDiv.style.display = "block";
                maisDetalheTxt.setAttribute("required", "required");
                  correcaoDiv.style.display = "flex";
                arquivoInput.setAttribute("required", "required");

                if (dataOption === "correcao") {
                    blocoUm.style.display = "flex";
                    inputCorrecao.setAttribute("required", "required");
                }
                break;
        }

        atualizarEstadoBotao();
    });
});


// Upload de Arquivo
const arquivoInput = document.getElementById('arquivoInput');
const label = document.querySelector('.upload-label');
const sizeWarm = document.querySelector(".picture span");

arquivoInput.addEventListener('change', function () {
    const file = this.files[0];
    if (file && file.size <= 3 * 1024 * 1024) {
        label.classList.add('valid');
        sizeWarm.innerHTML = file.name;
        sizeWarm.style.display = "flex";
        document.querySelector(".error-alert-picture").style.display = "none";
    } else {
        label.classList.remove('valid');
        sizeWarm.style.display = "none";
        this.value = ""; 
        document.querySelector(".error-alert-picture").style.display = "flex";
    }
    // 2. CORREÇÃO: Dispara validação ao anexar arquivo para atualizar botão
    validarFormulario(false); // Mostra erro se ainda inválido ou libera botão
    atualizarEstadoBotao();
});

// Máscara CPF
document.getElementById('inputCpfContato').addEventListener('input', function (e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);
    let formatted = value;
    if (value.length > 9) formatted = value.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
    else if (value.length > 6) formatted = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
    else if (value.length > 3) formatted = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
    e.target.value = formatted;
    
    atualizarEstadoBotao();
});

// Listeners
document.querySelectorAll('.form-campo').forEach(input => {
    // Enquanto digita: Validação silenciosa (só para acender/apagar botão)
    input.addEventListener('input', atualizarEstadoBotao);
    input.addEventListener('change', atualizarEstadoBotao);
    
    // 2. CORREÇÃO: Ao sair do foco (blur), mostra o alerta de erro se houver
    input.addEventListener('blur', function() {
        // Valida modo "barulhento" (mostra erros)
        validarFormulario(false);
        atualizarEstadoBotao();
    });
});


// --- 3. LÓGICA DE VALIDAÇÃO ---

function validarCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let soma = 0, resto;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
}

function validarFormulario(silent = false) {
    const form = document.getElementById('privacidade-form');
    const inputs = form.querySelectorAll('input:not([type="submit"]), textarea');
    const alertErrorsBox = document.querySelector('.alert-errors-submit');
    const alertErrorsContent = alertErrorsBox.querySelector('.alert-errors-content span');
    
    let camposInvalidos = [];
    const regexInvalido = /[<>{}[\]\\;'"`]/; 

    inputs.forEach(input => {
        // Ignora campos irrelevantes ou invisíveis
        if (input.type === 'hidden' && !['relacao_com_oi', 'direito_deseja_exercer'].includes(input.name)) return;
        
        // Verifica se o campo (ou seu pai) está visível
        if (input.style.display === 'none' || input.closest('div[style*="display: none"]')) return;

        const valor = input.value.trim();

        // 1. CORREÇÃO: Validação específica de arquivo vazio
        if (input.type === 'file' && input.hasAttribute('required')) {
            if (input.files.length === 0) {
                camposInvalidos.push("Anexe o documento de identificação.");
            }
        }
        // Validação de inputs normais obrigatórios
        else if (input.hasAttribute('required') && !valor) {
             if(input.name === 'relacao_com_oi' || input.name === 'direito_deseja_exercer') {
                 camposInvalidos.push("Selecione uma opção nos menus.");
             } else {
                 camposInvalidos.push("Preencha todos os campos obrigatórios.");
             }
        } 
        else if (valor && input.type !== 'file' && regexInvalido.test(valor)) {
            camposInvalidos.push("Remova caracteres especiais inválidos (< > { } ' \").");
        } 
        else if (input.name === "cpf_contato" && !validarCPF(valor)) {
            camposInvalidos.push("CPF inválido!");
        } 
        else if (input.name === "email_contato" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)) {
            camposInvalidos.push("E-mail inválido!");
        } 
        else if (input.name === "nome_completo" && valor.length < 3) {
            camposInvalidos.push("Nome completo muito curto.");
        }
    });

    camposInvalidos = [...new Set(camposInvalidos)];

    if (camposInvalidos.length > 0) {
        if (!silent) {
            alertErrorsBox.style.display = "flex";
            alertErrorsContent.textContent = camposInvalidos.join(" ");
        }
        return false;
    }
    
    if (!silent) alertErrorsBox.style.display = "none";
    return true;
}

function atualizarEstadoBotao() {
    const lgpdCheckbox = document.querySelector(".lgpd-checkbox input");
    const submitBtn = document.getElementById("formPrivacidadeSubmitButton");
    const submitInfo = document.querySelector(".button-submit-info");

    // Validação silenciosa para definir estado
    const isFormValid = validarFormulario(true); 
    const isLgpdChecked = lgpdCheckbox.checked;

    if (isFormValid && isLgpdChecked) {
        submitBtn.classList.add("valid");
        submitBtn.removeAttribute("disabled");
        submitInfo.style.display = "none";
        // Não esconde a caixa de erro aqui para respeitar a lógica do Blur (ponto 2)
        // A caixa de erro será controlada pelo validarFormulario(false) nos eventos
    } else {
        submitBtn.classList.remove("valid");
        submitBtn.setAttribute("disabled", "disabled");
        // Se quiser que a info volte a aparecer quando inválido:
        submitInfo.style.display = "flex"; 
    }
}

document.querySelector(".lgpd-checkbox input").addEventListener("change", function() {
    // Se marcou, roda validação barulhenta para mostrar o que falta se houver erro
    if(this.checked) validarFormulario(false);
    atualizarEstadoBotao();
});


// --- 4. ENVIO ---

async function enviarFormulario() {
    const form = document.getElementById("privacidade-form");
    const element = document.querySelector('[data-page-id]');
    const pageId = element ? element.getAttribute('data-page-id') : '';
    const formData = new FormData(form);

    try {
        const response = await fetch(`/lumis/service/formbuildercustom/rest/forms/${pageId}/answers`, {
            method: "POST",
            body: formData
        });
        
        if (!response.ok) throw new Error("Erro no servidor");

        if(window.location.href.includes("/nova-home/")){
            window.location.href = "/nova-home/portal-de-privacidade/solicitacao-enviada/";
        } else if (window.location.href.includes("/portal-de-privacidade/")) {
            window.location.href = "/portal-de-privacidade/solicitacao-enviada/";
        } else {
            window.location.href = "/solicitacao-enviada/";
        }
    } catch (error) {
        console.log("Erro no formulário:", error);
        mostrarErro("Erro ao enviar. Tente novamente.");
        resetarBotao();
    }
}

function mostrarErro(msg) {
    const alertBox = document.querySelector(".alert-errors-submit");
    const alertText = document.querySelector(".alert-errors-content span");
    if (alertBox && alertText) {
        alertText.innerText = msg;
        alertBox.style.display = "flex";
    }
}